<template>
  <v-app light class="no-border">
    <v-content> 
      <v-toolbar>
        <v-toolbar-title>
           <img src="/statics/img/logo_hmd.png" height="38px"></img>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="">
          <v-btn text to="/signin">Sign in</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fill-height grid-list-lg>
        <v-layout wrap justify-center>
          <v-flex xs12>
          </v-flex>
          <v-flex xs12 sm8 md6 lg6 class="text-xs-center">
            <h1 class="text-xs-center black--text" mt-10>Reset your password</h1>
            <v-divider class="my-5"></v-divider>
            <form>
              <!-- 1st password START -->
              <password 
                v-model="resetForm.password1"
                placeholder="Please enter a Password"
                @score="showScore"
              >
              </password>
              <!-- 1st password END -->

              <!-- password message START -->
              {{passwordMessage}}
              <!-- password message END -->

              <!-- 2nd password START -->
              <v-text-field
                type="password"
                v-model="resetForm.password2"
                label="Confirm password"
                :error-messages="errors.collect('password2')"
                v-validate="'required|min:8'"
                data-vv-name="password2"
                @keyup.enter="submit"
                required
              >
              </v-text-field>
              <!-- 2nd password END -->

              <!-- save button START -->
              <v-btn large @click="submit" @keyup.enter="submit" class="mb-3" color="secondary">Save</v-btn>
              <!-- save button END -->
              <v-spacer></v-spacer>
              <!-- support button START -->
              <a href='#/support' @click.native="">support</a>
              <!-- support button END -->
            </form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <content-footer></content-footer>
    <notify/>
  </v-app>
</template>

<script>
  import { login } from '../../../../utils/auth';
  import AccountService from './services/AccountService'
  import Password from 'vue-password-strength-meter'

  export default {
    $_veeValidate: {
      validator: 'new'
    },
    components: {
      Password,
    },
    data: function (){
      return {
        resetForm : {
          password1: '',
          password2: '',
        },
        passwordStrength: 0,
        passwordMessage: '',
      }
    },
    mounted: function () {
      this.clear()
    },
    methods: {
      submit () {
        this.$validator.validateAll().then((result) => {
          if (result && this.resetForm.password1 === this.resetForm.password2) {
            AccountService.sendNewPassword(this, this.resetForm.password1, this.resetForm.password2, this.$route.params.uid, this.$route.params.key)
          } else {
            this.$store.commit('push', {msg: 'both passwords aren\'t the same', color: 'error'})
          }
        });
      },
      clear () {
        this.signinForm.password = ''
        this.$validator.reset()
      },
      showScore(score){
        this.passwordStrength=score
        switch (score){
          case 0:
            this.passwordMessage = 'You know it\'s not good enough'
            break
          case 1:
            this.passwordMessage = 'You can do better than this'
            break
          case 2:
            this.passwordMessage = 'Just one more effort'
            break
          case 3:
            this.passwordMessage = 'Now we\'re good'
            break
          case 4:
            this.passwordMessage = 'Okay but make sure you remember that password!'
            break
        }
      }
    }
  }
</script>